<template>
  <div class="home-box">
    <PageTitle :title="pageTitle" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <stockTransferCreateForm
          :formData="formData"
          :proploading="loading"
        ></stockTransferCreateForm>
      </div>
    </v-row>
  </div>
</template>

<script>
import stockTransferCreateForm from "@/components/stockTransfer/stocktransfercreateform.vue";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "StockTransfer",
  components: {
    PageTitle,
    stockTransferCreateForm,
  },
  props: {},
  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      formData: {
        branch_code: "",
        items: [],
        status: "pending",
      },
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    pageTitle() {
      return "Stock Transfer";
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },

  methods: {},

  watch: {},
};
</script>
